export const formatSendReminderToast = ({ sentCount = 0, name } = {}) => {
  if (sentCount === 1 && name) {
    return `Reminder sent to ${name}.`
  }
  if (sentCount === 1) {
    return 'Reminder sent to 1 participant.'
  }
  if (sentCount > 1) {
    return `Reminder sent to ${sentCount} participants.`
  }
  return 'Participants already reminded today were skipped.'
}
